import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";
import { MetodoCargaDescarga } from 'app/models/requireme';
const controller = rpcController("CargaDescarga");

export const CargaDescarga = cacheResource({
    /**Obtiene un listado de las cargas y descargas segun cierto filtro */
    ConsultarCargasDescargas: async (filtro: models.CargaDescargaFiltro): Promise<models.CargaDescargaCajaRutaDto[]> => await controller('ConsultarCargasDescargas', {}, filtro),

    /*  *///ConsultaManifiestosCargasDescargas(ManifiestosCargaDescargaFiltro filtro)
    ConsultaManifiestosCargasDescargas: async (filtro: models.ManifiestosCargaDescargaFiltro): Promise<models.ManifiestosCargaDescargaRADView[]> => await controller('ConsultaManifiestosCargasDescargas', {}, filtro),

    /**Obtiene de todas las guias que se encuentran en el almacen de cierta sucursal, sus destinos y para cada destino, las rutas posibles que estos pueden tomar */
    ObtenerDestinosCargaEnSucursal: async (idCajaRuta: number): Promise<models.DestinoCargaDescarga[]> => await controller('ObtenerDestinosCargaEnSucursal', { idCajaRuta }),

    /**Obtiene todos los destinos de las guias que se encuentra arriba de una caja, este proceso se una en la descarga para determinar cuales guias se deben de bajar de la caja */
    ObtenerDestinosDescargaEnCaja: async (idCajaRuta: number): Promise<models.DestinoCargaDescarga[]> => await controller('ObtenerDestinosDescargaEnCaja', { idCajaRuta }),

    /**Inicia el proceso de carga y descarga para una caja */
    IniciarCargaDescarga: async (model: models.InicioCargaDescarga): Promise<number> => await controller('IniciarCargaDescarga', {}, model),

    /**Cancela una carga o descarga */
    CancelarCargaDescarga: async (idCargaDescarga: number): Promise<void> => await controller('CancelarCargaDescarga', { idCargaDescarga }),

    /**Da por finalizado un proceso de carga/descarga */
    FinalizarCargaDescarga: async (idCargaDescarga: number): Promise<void> => await controller('FinalizarCargaDescarga', { idCargaDescarga }),

    /**Reabre un proceso de carga/descarga*/
    ReabrirCargaDescarga: async (idCargaDescarga: number): Promise<void> => await controller('ReabrirCargaDescarga', { idCargaDescarga }),

    /**Obtiene una carga/descarga */
    GetCargaDescarga: async (id: number): Promise<models.CargaDescargaCajaRutaDto> => await controller('GetCargaDescarga', { id }),

    /**Escanea y agrega un folio fisico a una carga/descarga */
    EscanearFolio: async (folioFisico: string, idCargaDescarga: number, metodo: MetodoCargaDescarga): Promise<models.LecturaFolioFisico> => await controller('EscanearFolio', { folioFisico, idCargaDescarga, metodo }),

    /**Obtiene todas las guias en una carga/descarga */
    ObtenerGuiasEnCargaDescarga: async (idCargaDescarga: number): Promise<models.GuiaDTO[]> => await controller('ObtenerGuiasEnCargaDescarga', { idCargaDescarga }),

    /**Obtiene todos los servicios pendientes de acompletar una guia en una carga/descarga */
    ObtenerServiciosPendientes: async (idCargaDescarga: number): Promise<models.PendientesCargaDescarga> => await controller('ObtenerServiciosPendientes', { idCargaDescarga }),

    /**Obtiene el resumen de una carga/descarga */
    ObtenerResumen: async (idCargaDescarga: number): Promise<models.ResumenCargaDescarga> => await controller('ObtenerResumen', { idCargaDescarga }),

    /**Obtiene el reporte de manifiesto de una carga/descarga */
    ReporteManifiesto: async (idCargaDescarga: number): Promise<string> => await controller('ReporteManifiesto', { idCargaDescarga }),

    /**Obtiene el reporte de carga de administradores  */
    ReporteCargaAdministradores: async (idCamionRuta: number, idSegmento: number): Promise<string> => await controller('ReporteCargaAdministradores', { idCamionRuta, idSegmento }),

    /**Devuelve una lista con las guias en un camión de EAD a cierta fecha */
    GuiasEnCamion: async (idCamionEAD: number, fecha: Date | string): Promise<models.GuiaDTO[]> => await controller('GuiasEnCamion', { idCamionEAD, fecha }),

    /**Quita una guia de una carga/descarga */
    QuitarGuia: async (idCargaDescarga: number, idGuia: number): Promise<void> => await controller('QuitarGuia', { idCargaDescarga, idGuia }),

    /**Quita de la carga/descarga un servicio incompleto */
    QuitarServicioIncompleto: async (idCargaDescarga: number, idServicio: number, numeroFisico: number, tipo: models.TipoFolioFisico): Promise<void> => await controller('QuitarServicioIncompleto', { idCargaDescarga, idServicio, numeroFisico, tipo }),
}, {
        //No deben de tener cache las consultas
        ObtenerServiciosPendientes: true,
        ObtenerGuiasEnCargaDescarga: true
    }, {
        ReabrirCargaDescarga: true,
        CancelarCargaDescarga: true,
        IniciarCargaDescarga: true,
        FinalizarCargaDescarga: true,
        EscanearFolio: true,
        QuitarGuia: true,
        QuitarServicioIncompleto: true,
    });


// WEBPACK FOOTER //
// ./app/resources/items/cargadescarga.tsx